import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Chip } from "@mui/material";
import MainApi from "../../../../services/mainApi.service";
import { IIServices } from "../../../../models/i-service";

const ISERVICE_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/IService/";
const iserviceService = new MainApi<IIServices>(ISERVICE_ROUTE);

const translationPath = "page.4uBus.register.iService.";

const IServicesPage = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const columns: GridColDef<IIServices>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "description",
      headerName: t(translationPath + "description") || "Description",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "configs",
      headerName: t(translationPath + "configs") || "Configurations",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
    {
      field: "companyDigitalCertificate",
      headerName:
        t(translationPath + "company_digital_certificate") ||
        "Company Digital Certificate",
      renderCell: ({ row: { companyDigitalCertificate } }) => {
        if (companyDigitalCertificate) {
          return (
            <OverflowTooltip
              text={companyDigitalCertificate.name}
              tooltip={companyDigitalCertificate.name}
              textTransform="none"
              variant="body2"
            />
          );
        }
        return "-";
      },
    },
    {
      field: "uBusUser",
      headerName: t(translationPath + "u_bus_user") || "4uBus User",
      renderCell: ({ row: { uBusUser } }) => {
        if (uBusUser) {
          return (
            <OverflowTooltip
              text={uBusUser.name}
              tooltip={uBusUser.name}
              textTransform="none"
              variant="body2"
            />
          );
        }
        return "-";
      },
    },
    {
      field: "iServiceType",
      headerName: t(translationPath + "i_service_type") || "IService Type",
      renderCell: ({ row: { iServiceType } }) => {
        if (iServiceType) {
          return (
            <OverflowTooltip
              text={iServiceType.name}
              tooltip={iServiceType.name}
              textTransform="none"
              variant="body2"
            />
          );
        }
        return "-";
      },
    },
    {
      field: "methodType",
      headerName: t(translationPath + "method_type") || "Method Type",
      renderCell: ({ row: { methodType } }) => {
        if (methodType) {
          return (
            <OverflowTooltip
              text={methodType.name}
              tooltip={methodType.name}
              textTransform="none"
              variant="body2"
            />
          );
        }
        return "-";
      },
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 90,
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            label={
              params.value
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
            color={params.value ? "success" : "error"}
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IIServices>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IIServices>
      showDefaultMacroFilters={false}
      service={iserviceService}
      columns={columns}
      title={t(translationPath + "i_services")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={t(translationPath + "search")}
      addButtonLabel={t(translationPath + "add_i_service") || "Add Service"}
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default IServicesPage;
